import React from 'react';

import SkewBg from '@common/SkewBg';
import PageHeader from '@common/PageHeader';
import Flex from '@common/Flex';

import Quote from './Quote';
import Avatar from './Avatar';

import { AboutWrapper, AboutInfo } from './About.style';

const About = () => {
  return (
    <AboutWrapper id="about">
      <PageHeader>About Me</PageHeader>
      <SkewBg />
      <AboutInfo>
        <div>
          <Avatar src="myimg.jpg" />
        </div>
<p>
I am a passionate <b>Software Developer (Backend)</b> with strong expertise in{" "}
<b>Java</b>, always eager to build scalable and reliable systems.

  <br />
  <br />
  Currently, I’m a Software Engineer Intern at <b>Cashfree Payments</b>, where I
  spearheaded the end-to-end launch of <b>FraudShield</b> in Java with optimized
  SQL and strong testing, improving NR by 20%. I also built an LLM-driven
  Insights API by aggregating multi-source data to deliver actionable merchant
  intelligence.
  <br />
  <br />
  Previously, I developed automation systems like MCP servers and an AI
  assistant (CAIA) to boost support efficiency, and optimized RiskShield with
  caching + observability while maintaining sub-50ms p99 latency at scale. I’ve
  also worked as a Full Stack Developer at <b>Safeguard Realty</b>, building an
  auth microservice with RBAC and an OCR-based search system to reduce lookup
  time by 40%.
</p>


      </AboutInfo>

      <Flex justify="space-between" className="quotes__wrapper">
        <Quote>
          <p>“Simplicity is the baddest choice to be the best.“</p>
        </Quote>
        <Quote>
          <p>
            “I know I’m not successful enough, but I’m passionate enough not to
            worry about success.“
          </p>
        </Quote>
        <Quote>
          <p>
            “Creativity is the driver of an unstoppable train called Passion.”
          </p>
        </Quote>
      </Flex>
    </AboutWrapper>
  );
};

export default About;
